// Base Client
import { IParams } from "../../shared/DataTable/hooks/useSearchParams";
import { getApiToken, parseRpcError } from "../helpers";
import { getBffRequest } from "./base/api";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import {
	CaseSearchRequest,
	CaseSearchResponse,
	CasesListRequest,
	CasesListResponse,
	GetCaseRequest,
	GetCaseResponse,
	GetClaimsLampCaseRequest,
	GetClaimsLampCaseResponse,
	GetLampCaseRequest,
	GetLampCaseResponse
} from "./protos/messages/cases.message_pb";

export const searchMatchedCases = async (term: string, attyId?: number): Promise<CaseSearchResponse> => {
	const token: string = getApiToken();

	const request: CaseSearchRequest = new CaseSearchRequest();
	request.setTerm(term);
	if (attyId) request.setAttyid(attyId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.searchMatchedCases(request, {})
		.then((response: CaseSearchResponse) => response)
		.catch((err) => {
			throw err;
		});
};

export const getCase = async (caseId: number): Promise<GetCaseResponse> => {
	const token: string = getApiToken();

	const request: GetCaseRequest = new GetCaseRequest();
	request.setCaseId(caseId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getCase(request, {})
		.then((response: GetCaseResponse) => response)
		.catch((err) => {
			throw err;
		});
};

//GetClaimsLampCase takes in the claims ID and finds the lamp case associated with it and then returns the lamp case details.
export const getClaimsLampCase = async (caseId: number): Promise<GetClaimsLampCaseResponse> => {
	const token: string = getApiToken();

	const request: GetCaseRequest = new GetClaimsLampCaseRequest();
	request.setCaseId(caseId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getClaimsLampCase(request, {})
		.then((response: GetClaimsLampCaseResponse) => response)
		.catch((err) => {
			throw err;
		});
};

//GetLampCase takes in the lamp case ID and returns the lamp case details.
export const getLampCase = async (caseId: number): Promise<GetLampCaseResponse> => {
	const token: string = getApiToken();

	const request: GetLampCaseRequest = new GetLampCaseRequest();
	request.setCaseId(caseId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getLampCase(request, {})
		.then((response: GetLampCaseResponse) => response)
		.catch((err) => {
			throw err;
		});
};

export const getCasesList = async (cacheKeyObject: IParams, attyId?: number): Promise<CasesListResponse> => {
	const token: string = getApiToken();

	const request: CasesListRequest = new CasesListRequest();
	request.setPage(cacheKeyObject.page);
	request.setLimit(cacheKeyObject.limit);
	if (cacheKeyObject.sortField) request.setSortField(cacheKeyObject.sortField);
	if (cacheKeyObject.sortDirection) request.setSortDir(cacheKeyObject.sortDirection);
	if (cacheKeyObject.searchField) request.setSearchField(cacheKeyObject.searchField);
	if (cacheKeyObject.searchString) request.setSearchString(cacheKeyObject.searchString);
	if (attyId) request.setAttyId(attyId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.listCases(request, {})
		.then((response: CasesListResponse) => response)
		.catch((err) => {
			console.error(err);
			throw parseRpcError(err.message).errorMessage;
		});
};
